import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { LinkService } from '@core/services/link.service';
import { navCardComponentImports } from '@layout/nav/card/nav-card.imports';
import { ISubItem, ISubMenuItem } from '@layout/nav/interfaces/nav.type';
import { NODA_DOCS_LINK } from '@shared/constants/links';

@Component({
  selector: 'noda-nav-card',
  standalone: true,
  templateUrl: './nav-card.component.html',
  styleUrls: ['./nav-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: navCardComponentImports,
})
export class NavCardComponent {
  private document: Document = inject(DOCUMENT);
  private linkService: LinkService = inject(LinkService);
  private router: Router = inject(Router);

  public item: InputSignal<ISubItem> = input<ISubItem>();
  public isActive: InputSignal<boolean> = input<boolean>(true);
  public activeIconAvailable: InputSignal<boolean> = input<boolean>(false);
  protected iconName: Signal<string> = computed((): string => {
    const getPath = (iconName: string): string => `nav/${iconName}.svg#${iconName}`;

    return this.activeIconAvailable() && this.isCurrent()
      ? getPath(`${this.item().icon}-active`)
      : getPath(this.item().icon);
  });

  public linkClickHandler(url: string): void {
    if (url) {
      this.navigate(url);
    }
  }

  public isCurrent(item: ISubItem | ISubMenuItem = this.item()): boolean {
    return this.router.url.includes(item?.href || item?.link);
  }

  private addQueryForDocs(url: string): string {
    return url?.includes(NODA_DOCS_LINK) ? url + this.linkService.getQueryParams() : url;
  }

  private navigate(url: string): void {
    this.document.defaultView?.open(this.addQueryForDocs(url), '_blank');
  }
}
